export type NHLDivision = "Atlantic" | "Metropolitan" | "Central" | "Pacific";
export type NHLConference = "Eastern" | "Western";

export interface NHLTeam {
  id: string;
  name: string;
  abbr: string;
  city: string;
  logo: string;
  division: NHLDivision;
  conference: NHLConference;
}

// Using NHL.com official team logo CDN
const getNHLLogo = (teamAbbr: string) => 
  `https://assets.nhle.com/logos/nhl/svg/${teamAbbr}_light.svg`;

export const NHL_TEAMS: NHLTeam[] = [
  // Atlantic Division (Eastern Conference)
  { id: "bos", name: "Bruins", abbr: "BOS", city: "Boston", logo: getNHLLogo("BOS"), division: "Atlantic", conference: "Eastern" },
  { id: "buf", name: "Sabres", abbr: "BUF", city: "Buffalo", logo: getNHLLogo("BUF"), division: "Atlantic", conference: "Eastern" },
  { id: "det", name: "Red Wings", abbr: "DET", city: "Detroit", logo: getNHLLogo("DET"), division: "Atlantic", conference: "Eastern" },
  { id: "fla", name: "Panthers", abbr: "FLA", city: "Florida", logo: getNHLLogo("FLA"), division: "Atlantic", conference: "Eastern" },
  { id: "mtl", name: "Canadiens", abbr: "MTL", city: "Montreal", logo: getNHLLogo("MTL"), division: "Atlantic", conference: "Eastern" },
  { id: "ott", name: "Senators", abbr: "OTT", city: "Ottawa", logo: getNHLLogo("OTT"), division: "Atlantic", conference: "Eastern" },
  { id: "tbl", name: "Lightning", abbr: "TBL", city: "Tampa Bay", logo: getNHLLogo("TBL"), division: "Atlantic", conference: "Eastern" },
  { id: "tor", name: "Maple Leafs", abbr: "TOR", city: "Toronto", logo: getNHLLogo("TOR"), division: "Atlantic", conference: "Eastern" },

  // Metropolitan Division (Eastern Conference)
  { id: "car", name: "Hurricanes", abbr: "CAR", city: "Carolina", logo: getNHLLogo("CAR"), division: "Metropolitan", conference: "Eastern" },
  { id: "cbj", name: "Blue Jackets", abbr: "CBJ", city: "Columbus", logo: getNHLLogo("CBJ"), division: "Metropolitan", conference: "Eastern" },
  { id: "njd", name: "Devils", abbr: "NJD", city: "New Jersey", logo: getNHLLogo("NJD"), division: "Metropolitan", conference: "Eastern" },
  { id: "nyi", name: "Islanders", abbr: "NYI", city: "New York", logo: getNHLLogo("NYI"), division: "Metropolitan", conference: "Eastern" },
  { id: "nyr", name: "Rangers", abbr: "NYR", city: "New York", logo: getNHLLogo("NYR"), division: "Metropolitan", conference: "Eastern" },
  { id: "phi", name: "Flyers", abbr: "PHI", city: "Philadelphia", logo: getNHLLogo("PHI"), division: "Metropolitan", conference: "Eastern" },
  { id: "pit", name: "Penguins", abbr: "PIT", city: "Pittsburgh", logo: getNHLLogo("PIT"), division: "Metropolitan", conference: "Eastern" },
  { id: "wsh", name: "Capitals", abbr: "WSH", city: "Washington", logo: getNHLLogo("WSH"), division: "Metropolitan", conference: "Eastern" },

  // Central Division (Western Conference)
  { id: "chi", name: "Blackhawks", abbr: "CHI", city: "Chicago", logo: getNHLLogo("CHI"), division: "Central", conference: "Western" },
  { id: "col", name: "Avalanche", abbr: "COL", city: "Colorado", logo: getNHLLogo("COL"), division: "Central", conference: "Western" },
  { id: "dal", name: "Stars", abbr: "DAL", city: "Dallas", logo: getNHLLogo("DAL"), division: "Central", conference: "Western" },
  { id: "min", name: "Wild", abbr: "MIN", city: "Minnesota", logo: getNHLLogo("MIN"), division: "Central", conference: "Western" },
  { id: "nsh", name: "Predators", abbr: "NSH", city: "Nashville", logo: getNHLLogo("NSH"), division: "Central", conference: "Western" },
  { id: "stl", name: "Blues", abbr: "STL", city: "St. Louis", logo: getNHLLogo("STL"), division: "Central", conference: "Western" },
  { id: "uta", name: "Utah Hockey Club", abbr: "UTA", city: "Utah", logo: getNHLLogo("UTA"), division: "Central", conference: "Western" },
  { id: "wpg", name: "Jets", abbr: "WPG", city: "Winnipeg", logo: getNHLLogo("WPG"), division: "Central", conference: "Western" },

  // Pacific Division (Western Conference)
  { id: "ana", name: "Ducks", abbr: "ANA", city: "Anaheim", logo: getNHLLogo("ANA"), division: "Pacific", conference: "Western" },
  { id: "cgy", name: "Flames", abbr: "CGY", city: "Calgary", logo: getNHLLogo("CGY"), division: "Pacific", conference: "Western" },
  { id: "edm", name: "Oilers", abbr: "EDM", city: "Edmonton", logo: getNHLLogo("EDM"), division: "Pacific", conference: "Western" },
  { id: "lak", name: "Kings", abbr: "LAK", city: "Los Angeles", logo: getNHLLogo("LAK"), division: "Pacific", conference: "Western" },
  { id: "sjs", name: "Sharks", abbr: "SJS", city: "San Jose", logo: getNHLLogo("SJS"), division: "Pacific", conference: "Western" },
  { id: "sea", name: "Kraken", abbr: "SEA", city: "Seattle", logo: getNHLLogo("SEA"), division: "Pacific", conference: "Western" },
  { id: "van", name: "Canucks", abbr: "VAN", city: "Vancouver", logo: getNHLLogo("VAN"), division: "Pacific", conference: "Western" },
  { id: "vgk", name: "Golden Knights", abbr: "VGK", city: "VGK", logo: getNHLLogo("VGK"), division: "Pacific", conference: "Western" },
];

export const NHL_DIVISIONS: NHLDivision[] = ["Atlantic", "Metropolitan", "Central", "Pacific"];

export const getTeamByAbbr = (abbr: string): NHLTeam | undefined => {
  return NHL_TEAMS.find((team) => team.abbr === abbr);
};

export const getTeamsByDivision = (division: NHLDivision): NHLTeam[] => {
  return NHL_TEAMS.filter((team) => team.division === division);
};
